import { useDispatch, useSelector } from "react-redux";
import { USER, USERALL, COMPANY, PROJECT, WORKSITE, WORKSITEALL } from "../../services/actions";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Container, Box, Grid, Pagination } from "@mui/material";
import InfoCard2 from "../extra/InfoCard2";
import Form from "./SiteForm";
import ActionBar from "../extra/ActionBar";
import SearchBar from "../extra/SearchBar";
import XTable from "../extra/XTableAnother";
import { layouts } from "chart.js";
import MoreInfo from "../extra/MoreInfo";

export default function View() {
  let dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { project } = location.state || {};
  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1); // Added state for view
  const [companies, setCompanies] = React.useState([]);
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchSites = (page = 0) => {
    const url = page === 0 ? `worksites/${page}/?filter_by={"project_id":"${project.id}"}` : `worksites/?page=${page}&filter_by={"project_id":"${project.id}"}`; // pass page number
    dispatch({ type: `${WORKSITEALL}_GET`, payload: url });
  };

  let worksiteallState = useSelector((state) => state?.worksiteallState);
  let worksiteState = useSelector((state) => state?.worksiteState);
  let user = useSelector((state) => state?.loginState?.auth);

  React.useEffect(() => {
    try {
      fetchSites(0);
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchSites(page);
  }, [page]);

  React.useEffect(() => {
    if (worksiteState.success) {
      setOpen(false);
      fetchSites(0);
    }
  }, [worksiteState?.data]);

  // Handle filter search
  const handleSearch = (key, value) => {
    console.log(key, value);
    const query = `worksites/0/?filter_by={"${key}__istartswith":"${value}","project_id":${project.id}}`;
    dispatch({ type: `${WORKSITEALL}_GET`, payload: query });
  };

  // Prepare data for XTable
  const tableHeadings = [
    "ID",
    "Image",
    "Site Name",
  ];
  const tableRows = worksiteallState?.data?.results?.map((user) => ({
    id: user.id, // Include ID to find the original data on edit
    image: user.avatar,
    site_name: user.site_name,
  }));

  const handleEdit = (data) => {
    setDefV({ ...data });
    setOpen(true);
  };

  const handleDelete = (id) => {
    dispatch({ type: `${WORKSITE}_DELETE`, payload: id });
  };

  return (
    <>
      <Container maxWidth="false" className="py-3">
        <ActionBar
          showGrid={[2, 5]}
          onBtnClick={(type, col) => {
            if (type === "grid") {
              setView(1);
            }
            if (type === "tabular") {
              setView(2);
            }
            if (type === "previous") {
              navigate('/progress/')
            }
          }}
          hasPermission={user?.permissions?.includes("work_progs.add_worksite")}
          label={project.project_name}
          setOpen={(s) => {
            setDefV({}); // Reset default values
            setOpen(true);
          }}
          btnLabel="ADD SITE"
          btnPrevLabel="BACK"
        />

        {open ? <Form
          defaultValues={defV}
          onSubmit={(data) => {
            data.project = project?.id
            let ACTION = data.id ? `${WORKSITE}_PATCH` : `${WORKSITE}_POST`;
            dispatch({ type: ACTION, payload: data });
          }}

          back={() => {
            setOpen(false);
          }}
        /> : <>
          <SearchBar bylist={["site_name"]} handleSearch={handleSearch} />

          {view === 1 && (
            <>
              <Grid container spacing={2}>
                {worksiteallState?.data?.results?.map((data) => {
                  data.image = user;
                  return (
                    <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                      <InfoCard2
                        sx={{
                          height: 300, // Use the prop, or a default value
                        }}
                        keys={[
                          "image",
                          "site_name",
                          "username",
                          "main_role",
                          "Total",
                          "project_count",
                          "Closed",
                          "timelapse_camera_count",
                          "Open",
                          "live_camera_count",
                          "last_name",
                        ]}
                        data={data}
                        onClick={() => {
                          //navigate("/timelapse-preview/", {})
                        }}
                        onAction={(action, data) => {
                          if (action == "Edit") {
                            handleEdit(data); // Call the shared edit handler
                          } else if (action == "Delete") {
                            handleDelete(data.id); // Call the shared delete handler
                          } else if (action == "More") {
                            navigate("/tasks/", {
                              state: {
                                project: project,
                                site: data
                              },
                            });
                          }
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  count={Math.ceil(worksiteallState?.data?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}

          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={handleEdit} // Use the shared handler
              onDelete={handleDelete} // Use the shared handler
            />
          )}
          {view === 3 && (
            <MoreInfo
              data={{
                ...defV,
                is_active: defV.is_active ? "Yes" : "No",
                // verify: defV.verify ? "Yes" : "No",
              }}
              skip={[
                "avatar",
                "address",
                "refresh_token",
                "token",
                "is_social_login",
                "shared_key",
                "whatsapp_number"

              ]}
              group={["first_name", "last_name", "username", "created_at"]}
              // icons={{ access_loation: <BsCopy /> }}
              // css={{ access_location: { color: '#1976d2' } }}
              onClose={() => {
                setView(1);
              }}
            />
          )}
        </>}
      </Container>
    </>
  );
}
